import { RefObject } from 'react'

import { useScrollspy } from './useScrollspy'

export { useScrollspy }

type Props = {
  children: ({
    currentElementIndexInViewport,
    elementsStatusInViewport,
  }: {
    currentElementIndexInViewport: number
    elementsStatusInViewport: boolean[]
  }) => JSX.Element
  disableUnselected?: boolean
  offset?: number
  rootSelector?: string
  sectionRefs: RefObject<Element>[]
}

const Scrollspy = ({ children, disableUnselected, offset, rootSelector, sectionRefs }: Props) => {
  const { currentElementIndexInViewport, elementsStatusInViewport } = useScrollspy({
    disableUnselected,
    offset,
    rootSelector,
    sectionRefs,
  })

  return children({
    currentElementIndexInViewport,
    elementsStatusInViewport,
  })
}

export default Scrollspy
